// The RTK Query APIs whose cache lifecycle middleware has to be in the store.
// Add a new API to the list below and nothing in store composition changes.
//
// Each api.middleware only handles its own `<reducerPath>/*` actions and passes
// everything else straight through, so the saga and thunk pipelines in
// ./middleware are unaffected regardless of how many are registered here.
//
// Note this covers middleware only; an API's cache reducer is still registered
// by hand in ../reducers.
import { riskAreasApi } from "../pages/analyzer/risk-areas-new/services/risk-areas-api";

export const rtkQueryApis = [riskAreasApi];

export const apiMiddleware = rtkQueryApis.map((api) => api.middleware);
